<template lang="pug">
.neutral200
  v-container.px-8.py-6(fluid style="max-width:1600px")
    v-row(no-gutters)
      v-col.px-2(:cols="tabs && tabs <= 3 ? 9 : 12")
        v-row(no-gutters)
          v-col(cols="8")
            v-tabs(v-model="tabs" color="basic700" background-color="transparent" height="44" @change="" )
              v-tab.text-sm.font-normal.text-none Overview
              v-tab.text-sm.font-normal.text-none Offers
              v-tab.text-sm.font-normal.text-none Loyalty
              v-tab.text-sm.font-normal.text-none Reviews
              v-tab.text-sm.font-normal.text-none Customers
          v-col(cols="4" align="right")
            template(v-if="tabs && tabs <= 3")
              y-button.mr-6(v-if="tabs === 2" label="Loyalty settings" underline button-class="px-0" style="height: 36px !important;" @click="goToLoyaltySettings")
              y-button.mr-6(v-if="tabs === 3" label="Review settings" underline button-class="px-0" style="height: 36px !important;" @click="goToReviewSettings")
              //- Disable Review
              v-btn(v-if="tabs === 3" icon disabled)
                v-icon(color="neutral400" size="32") $yzi-plus-circle
              //- Enable Else
              template(v-else)
                v-menu(offset-y left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon v-on="on")
                      v-icon(color="neutral700" size="32") $yzi-plus-circle
                  //- Offers
                  v-list.py-0(v-if="tabs === 1" align="left")
                    v-list-item(style="min-height: 32px;")
                      v-list-item-title.text-xs.font-medium.neutral700--text Offers
                    v-divider
                    v-list-item(@click="openRedeemOfferDialog = true")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-3(color="neutral700" size="16") $yzi-gift-solid-01
                          div.text-sm.neutral700--text Redeem offer
                    v-divider
                    v-list-item(@click="createNewOffer")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-3(color="neutral700" size="16") $yzi-coins-hand-solid
                          div.text-sm.neutral700--text Create offer
                  //- Loyalty
                  v-list.py-0(v-if="tabs === 2" align="left")
                    v-list-item(style="min-height: 32px;")
                      v-list-item-title.text-xs.font-medium.neutral700--text Loyalty program
                    v-divider
                    v-list-item(@click="openEnrolMemberDialog = true")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-3(color="neutral700" size="16") $yzi-user-plus-solid-01
                          div.text-sm.neutral700--text Enrol new member
                    v-divider
                    v-list-item(v-if="marketingSettings" @click="handleCollectValue")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-3(color="neutral700" size="16") $yzi-coins-hand-solid
                          div.text-sm.neutral700--text Collect {{ marketingSettings.loyalty_system }}
                    v-divider
                    v-list-item(@click="handleRedeemReward")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-3(color="neutral700" size="16") $yzi-gift-solid-01
                          div.text-sm.neutral700--text Redeem reward

        v-divider
        
        v-tabs-items.mt-2(v-model="tabs" style="overflow: visible;")
          v-tab-item
            overview(ref="overview")
          v-tab-item
            offers
          v-tab-item
            loyalty(ref="loyalty")
          v-tab-item
            div.neutral200.pt-2
              v-card.round-lg.pa-8(outlined)
                review
          v-tab-item
            div.neutral200.pt-2.pb-10
              v-card.round-lg(outlined)
                customers

      v-col.px-2(:cols="tabs && tabs <= 3 ? 3 : 0")
        v-tabs-items.mt-2(v-model="tabs" style="overflow: visible;")
          v-tab-item
          v-tab-item
            offers-activities
          v-tab-item
            loyalty-activities
          v-tab-item
            review-activities

  .dialogs
    enrol-new-member-dialog(v-if="openEnrolMemberDialog" :open.sync="openEnrolMemberDialog" :loyalty-system="marketingSettings.loyalty_system" @updated="updateMemberLoyalty" @collect="handleMemberCollectValue($event)")
    collect-value-dialog(v-if="openCollectValueDialog" :open.sync="openCollectValueDialog" :loyalty-system="marketingSettings.loyalty_system" :rewards-position="rewardsPosition" :member="selectedMember" member-selectable @refetch="handleUpdateLoyalty" @redeem="handleRedeemRewardOnSelectedMember")
    redeem-reward-dialog(v-if="openRedeemRewardDialog" :open.sync="openRedeemRewardDialog" :loyalty-system="marketingSettings.loyalty_system" :rewards-position="rewardsPosition" member-selectable :member="selectedMember" @refetch="handleUpdateLoyalty")
    redeem-offer-dialog(v-if="openRedeemOfferDialog" :open.sync="openRedeemOfferDialog" customer-selectable)
</template>

<script>
import { mapGetters } from 'vuex'
import Overview from '@/components/clinic/marketing/Overview.vue'
import Offers from '@/components/clinic/marketing/Offers.vue'
import Loyalty from '@/components/clinic/marketing/Loyalty.vue'
import Review from '@/components/review/listing/ReviewListingPage.vue'
import Customers from '@/components/clinic/marketing/Customers.vue'
import OffersActivities from '@/components/clinic/marketing/OffersActivities.vue'
import LoyaltyActivities from '@/components/clinic/marketing/LoyaltyActivities.vue'
import ReviewActivities from '@/components/clinic/marketing/ReviewActivities.vue'
import EnrolNewMemberDialog from '@/components/clinic/marketing/dialogs/EnrolNewMemberDialog.vue'
import CollectValueDialog from "@/components/clinic/checkout/marketing/collecting/CollectValueDialog.vue";
import RedeemRewardDialog from "@/components/clinic/checkout/marketing/redeem/reward/RedeemRewardDialog.vue";
import RedeemOfferDialog from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferDialog.vue";

export default {
  name: 'Marketing',
  components: {
    RedeemOfferDialog, RedeemRewardDialog, CollectValueDialog, Overview, Offers, Loyalty, Review, Customers,
    OffersActivities, LoyaltyActivities, ReviewActivities, EnrolNewMemberDialog
  },
  props: ['reset'],
  data() {
    return {
      openEnrolMemberDialog: false,
      openCollectValueDialog: false,
      openRedeemRewardDialog: false,
      openRedeemOfferDialog: false,
      selectedMember: null
    }
  },
  created () {
    if (this.reset) this.$store.commit('marketing/resetMarketing')
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      marketingTabs: 'marketing/getMarketingTabs',
      marketingSettings: 'marketing/getMarketingSettings',
      loyaltySettings: 'marketing/getLoyaltySettings'
    }),
    tabs: {
      get () {
        return this.marketingTabs
      },
      set (val) {
        this.$store.commit('marketing/setMarketingTabs', val)
      }
    },
    rewardsPosition() {
      return this.loyaltySettings?.rewards?.map(reward => reward.tier_value) || []
    },
  },
  watch: {
    tabs (val, oldval) {
      if (oldval === 0 && val) {
        if (this.$refs.overview) this.$refs.overview.cancelRequest()
      } else if (oldval && val === 0) {
        if (this.$refs.overview) {
          if (this.$refs.overview.cancelledRequest === true || this.$refs.overview.$refs.salescomparison.cancelledRequest === true) {
            this.$refs.overview.fetchOverviews()
            this.$refs.overview.$refs.salescomparison.fetchData()
          }
        }
      }
    }
  },
  mounted () {
    this.fetchMarketingSettings()
    this.fetchLoyaltySettings()
  },
  methods: {
    fetchMarketingSettings () {
      this.$axios.get(`/marketing/${this.company.slug}`)
        .then(resp => {
          this.$store.commit('marketing/setMarketingSettings', resp.data)
        })
        .catch(() => {})
    },
    updateMemberLoyalty () {
      this.$refs.loyalty.fetchMembers()
    },
    goToLoyaltySettings () {
      this.$router.push('/admin/clinic/marketing/loyalty/settings')
    },
    goToReviewSettings () {
      this.$router.push('/admin/clinic/marketing/review/settings')
    },
    createNewOffer () {
      this.$router.push(`/admin/clinic/marketing/offer/create`)
    },
    fetchLoyaltySettings () {
      this.$axios.get(`/loyalty/${this.company.slug}`)
        .then(resp => {
          this.$store.commit('marketing/setLoyaltySettings', resp.data)
        })
        .catch(() => {})
    },
    updateLoyaltyStats () {
      this.$refs.loyalty.fetchStats()
    },
    handleUpdateLoyalty () {
      this.updateMemberLoyalty()
      this.updateLoyaltyStats()
    },
    handleCollectValue () {
      this.selectedMember = null
      this.openCollectValueDialog = true
    },
    handleMemberCollectValue (member) {
      this.selectedMember = member
      this.openCollectValueDialog = true
    },
    handleRedeemReward () {
      this.selectedMember = null
      this.openRedeemRewardDialog = true
    },
    handleRedeemRewardOnSelectedMember (selectedMember) {
      this.selectedMember = selectedMember
      this.openRedeemRewardDialog = true
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
